export const formatDate = (dateString: any) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    // hour: 'numeric',
    // minute: 'numeric',
  }).format(date);
};

export const formatDateTime = (dateString: any) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    // year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  }).format(date);
};

export const formatTime = (timeString: any) => {
  if (!timeString) return 'Shift information. N/A.';
  const date = new Date(timeString);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

// import { format, zonedTimeToUtc, utcToZonedTime, parse } from 'date-fns-tz';

// /**
//  * Formats a UTC ISO string from the API into a user-friendly, localized date/time string.
//  * This is the primary function for DISPLAYING full dates and times in the UI.
//  * @param utcIsoString - The UTC date string from your API (e.g., "2025-08-15T13:00:00.000Z").
//  * @param timezone - The IANA timezone of the logged-in user's organization.
//  * @param formatString - The desired display format. Defaults to a common readable format.
//  * @returns A formatted, localized date string.
//  */
// export function formatUtcToLocal(
//   utcIsoString,
//   timezone,
//   formatString = 'MMM d, yyyy, h:mm a',
// ) {
//   if (!utcIsoString || !timezone) {
//     return 'N/A';
//   }
//   try {
//     // The 'zzz' token is great for showing the timezone abbreviation (e.g., EDT, PST)
//     return format(
//       utcToZonedTime(utcIsoString, timezone),
//       `${formatString} zzz`,
//       {
//         timeZone: timezone,
//       },
//     );
//   } catch (error) {
//     console.error('Failed to format date in formatUtcToLocal:', {
//       utcIsoString,
//       timezone,
//       error,
//     });
//     return 'Invalid date';
//   }
// }

// /**
//  * Formats a UTC ISO string from the API into a user-friendly, localized DATE ONLY string.
//  * @param utcIsoString - The UTC date string from your API.
//  * @param timezone - The IANA timezone of the user's organization.
//  * @returns A formatted, localized date string, e.g., "Aug 15, 2025".
//  */
// export function formatDateOnly(utcIsoString, timezone) {
//   if (!utcIsoString || !timezone) {
//     return 'N/A';
//   }
//   // No need for a time format string here
//   return formatUtcToLocal(utcIsoString, timezone, 'MMM d, yyyy');
// }

// /**
//  * Takes a "local" date string (e.g., from an <input type="datetime-local">) and converts
//  * it to a full UTC ISO 8601 string, ready to be sent to the backend.
//  * This is the primary function for PREPARING dates to be sent to the API.
//  * @param localDateTimeString - The local date string, e.g., "2025-08-15T09:00:00".
//  * @param timezone - The IANA timezone of the user's organization.
//  * @returns A full UTC ISO string, e.g., "2025-08-15T13:00:00.000Z".
//  */
// export function convertLocalToUtcString(localDateTimeString, timezone) {
//   if (!localDateTimeString || !timezone) {
//     return null;
//   }
//   try {
//     const utcDate = zonedTimeToUtc(localDateTimeString, timezone);
//     return utcDate.toISOString();
//   } catch (error) {
//     console.error('Failed to convert date in convertLocalToUtcString:', {
//       localDateTimeString,
//       timezone,
//       error,
//     });
//     return null;
//   }
// }

// /**
//  * NEW: Checks if the current time is within a given shift time range for a specific timezone.
//  * Handles overnight shifts correctly.
//  * @param {string} shiftStart - The start time of the shift, e.g., "09:00" or "22:00".
//  * @param {string} shiftEnd - The end time of the shift, e.g., "17:00" or "06:00".
//  * @param {string} timezone - The IANA timezone of the organization.
//  * @returns {boolean} - True if currently on shift, false otherwise.
//  */
// export function isCurrentlyOnShift(shiftStart, shiftEnd, timezone) {
//   if (!shiftStart || !shiftEnd || !timezone) {
//     return false;
//   }
//   try {
//     const nowInOrgTimezone = utcToZonedTime(new Date(), timezone);

//     const baseDate = format(nowInOrgTimezone, 'yyyy-MM-dd', {
//       timeZone: timezone,
//     });

//     let startDateTime = parse(
//       `${baseDate}T${shiftStart}`,
//       "yyyy-MM-dd'T'HH:mm",
//       new Date(),
//     );
//     let endDateTime = parse(
//       `${baseDate}T${shiftEnd}`,
//       "yyyy-MM-dd'T'HH:mm",
//       new Date(),
//     );

//     // Handle overnight shifts (e.g., 22:00 to 06:00)
//     if (endDateTime < startDateTime) {
//       // If current time is after start time, it's part of the same day's shift
//       // If current time is before end time, it's part of the previous day's shift that crossed midnight
//       if (nowInOrgTimezone < endDateTime) {
//         // Adjust start time to be "yesterday"
//         startDateTime.setDate(startDateTime.getDate() - 1);
//       } else {
//         // Adjust end time to be "tomorrow"
//         endDateTime.setDate(endDateTime.getDate() + 1);
//       }
//     }

//     return nowInOrgTimezone >= startDateTime && nowInOrgTimezone <= endDateTime;
//   } catch (error) {
//     console.error('Error in isCurrentlyOnShift:', {
//       shiftStart,
//       shiftEnd,
//       timezone,
//       error,
//     });
//     return false;
//   }
// }

// /**
//  * NEW: Formats a time string for consistent display.
//  * @param {string} timeString - A time string, e.g., "09:00" or "17:30".
//  * @returns {string} - A formatted time, e.g., "9:00 AM".
//  */
// export function formatTimeForDisplay(timeString) {
//   if (!timeString) return 'N/A';
//   try {
//     const date = parse(timeString, 'HH:mm', new Date());
//     return format(date, 'h:mm a');
//   } catch (error) {
//     console.error('Error formatting time:', { timeString, error });
//     return 'Invalid Time';
//   }
// }
